var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center",staticStyle:{"height":"calc(100vh - 58px)"},attrs:{"fill-height":""}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t("pages.finished.headline"))+" ")]),_c('p',[_vm._v(_vm._s(_vm.$t("pages.finished.body")))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }